module.exports = __webpack_public_path__ + "img/home.b471f20d.svg";